import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';
import { MyBetsToggleSchema } from '@/components/MyBetsToggle/styles/MyBetsToggle.styles';

export const myBetsToggleStyles: MyBetsToggleSchema = {
  textCashOut: { color: 'whiteAlpha.900' },
  flexWrapper: {
    flexDir: 'row',
  },
  checkbox: {
    my: 'auto',
  },
};

export const TabContainer: CSSObject = {
  borderBottom: '0',
  bg: 'blackAlpha.400',
  boxShadow:
    '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  borderRadius: 'base',
  px: '4',
};

export const buttonAccountTabOptionProps: CustomButtonProps = {
  variant: 'tab',
  sx: {
    '&[aria-selected="true"]': {
      color: 'beta.500',
      fontWeight: 'normal',
      textShadow: '0px 0px 8px rgba(251, 201, 21, 0.50)',
      border: 'none',
      borderBottom: '4px solid',
      borderBottomColor: 'beta.500',
    },
  },
};
